import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c(VBtn,{attrs:{"icon":"","small":""}},[_c(VIcon,[_vm._v("mdi-plus")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }